import DialogActionButtonsSection from './components/DialogActionButtonsSection'
import { useContext } from 'react'
import { AppContext, AppContextType, ScreenRecordingInfo } from '../AppContext'
import { useTranslation } from 'react-i18next'
import CrossPlatformDialog from './components/CrossPlatformDialog'
import { DialogBody } from '@/components/Dialog'
import ElectronIPC from '@/services/ElectronIPC'

export default function ScreenRecordingConversionDialogController() {
    const { state: appState, dispatch: appDispatch } = useContext(AppContext) as AppContextType

    const onCloseDialog = () => {
        appDispatch({ type: 'update_app_state', value: { showScreenRecordingConversionDialog: null } })
    }

    if (appState.appState.showScreenRecordingConversionDialog) {
        return (
            <CrossPlatformDialog frameName={`Dialog:ScreenRecordingConversionDialog`} onDefaultClose={onCloseDialog}>
                <DialogContent
                    data={appState.appState.showScreenRecordingConversionDialog.convertedFileInfo}
                    onClose={onCloseDialog}
                />
            </CrossPlatformDialog>
        )
    } else {
        return null
    }
}

const DialogContent = ({ onClose, data }: { onClose: () => void; data: ScreenRecordingInfo }) => {
    const { t } = useTranslation()

    return (
        <div className="w-full">
            <DialogBody>
                <div className="pb-4" style={{ wordWrap: 'break-word' }}>
                    Screen recording <i>{data.outputFilename}</i> saved.
                </div>
            </DialogBody>

            <DialogActionButtonsSection
                leftButtonText={t('Close') || 'Close'}
                rightButtonText={'Open folder'}
                onLeftButtonClicked={onClose}
                onRightButtonClicked={() => {
                    ElectronIPC.openPath(data.outputFileDirectory)
                    onClose()
                }}
            />
        </div>
    )
}
